import jwtDecode from 'jwt-decode';

export const decodeToken = (token) => {
  try{
    return jwtDecode(token);
  }catch(err){
    console.log("🤖[TOKEN COULD NOT BE DECODED]")
    throw new Error('Invalid Token')
  }
};

export const  isTokenFromBR = (token) => {
  try{
    const tokenPayload = decodeToken(token);
    return tokenPayload?.country === 'BR'
  }catch(err){
    
    console.log("🤖[TOKEN COULD NOT BE DECODED]")
    throw new Error('Invalid Token')
  }
};

export const isTokenExpired = (token) => {
  try{
    const { exp } = decodeToken(token);
    return (exp < Date.now() / 1000);
  }catch(err){
    console.log("🤖[TOKEN COULD NOT BE DECODED]")
    throw new Error('Invalid Token')
  }
};